unit View.Grade_Produtos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewGrade_ProdutosList = class(TForm)
    btNew: TButton;
    Grade_ProdutosDataset: TXDataWebDataSet;
    Grade_ProdutosDatasetid: TIntegerField;
    Grade_ProdutosDatasetaliado_id: TIntegerField;
    Grade_ProdutosDatasetdata_base_id: TIntegerField;
    Grade_ProdutosDatasetgrade_linha_id: TIntegerField;
    Grade_ProdutosDatasetgrade_coluna_id: TIntegerField;
    Grade_ProdutosDatasetprodutos_id: TIntegerField;
    Grade_ProdutosDatasetnome: TStringField;
    Grade_ProdutosDatasetcodigo_barras: TStringField;
    Grade_ProdutosDatasetcodigo_fabrica: TStringField;
    Grade_ProdutosDatasetestoque: TFloatField;
    Grade_ProdutosDatasetestoque_retido: TFloatField;
    Grade_ProdutosDatasetestoque_maximo: TFloatField;
    Grade_ProdutosDatasetestoque_minimo: TFloatField;
    Grade_ProdutosDatasetstatus: TIntegerField;
    Grade_ProdutosDatasetcadastro: TDateTimeField;
    Grade_ProdutosDatasetcodigo_interno: TIntegerField;
    Grade_ProdutosDatasetexcluido: TBooleanField;
    Grade_ProdutosDatasetinclusao: TDateTimeField;
    Grade_ProdutosDatasetalteracao: TDateTimeField;
    Grade_ProdutosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_ProdutosList: TFViewGrade_ProdutosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_ProdutosList }

procedure TFViewGrade_ProdutosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewGrade_ProdutosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_ProdutosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewGrade_ProdutosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_ProdutosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewGrade_ProdutosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewGrade_ProdutosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Grade_ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(Grade_ProdutosDataset.EntitySetName),
      Grade_ProdutosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewGrade_ProdutosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('grade_produtos', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetValorDicionarioClasses('grades_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_grades', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Grade_ProdutosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewGrade_ProdutosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.grade_produtos.list.pagination.info');
  btNew := TButton.Create('view.grade_produtos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.grade_produtos.list.table');
  cbPageSize := TComboBox.Create('view.grade_produtos.list.cbPageSize');
  edSearch := TEdit.Create('view.grade_produtos.list.search');
  lcPaginator := TListControl.Create('view.grade_produtos.list.pagination');
  Grade_ProdutosDataset := TXDataWebDataSet.Create(Self);
  Grade_ProdutosDatasetid := TIntegerField.Create(Self);
  Grade_ProdutosDatasetaliado_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetgrade_linha_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetgrade_coluna_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetprodutos_id := TIntegerField.Create(Self);
  Grade_ProdutosDatasetnome := TStringField.Create(Self);
  Grade_ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  Grade_ProdutosDatasetcodigo_fabrica := TStringField.Create(Self);
  Grade_ProdutosDatasetestoque := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_retido := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_maximo := TFloatField.Create(Self);
  Grade_ProdutosDatasetestoque_minimo := TFloatField.Create(Self);
  Grade_ProdutosDatasetstatus := TIntegerField.Create(Self);
  Grade_ProdutosDatasetcadastro := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_ProdutosDatasetexcluido := TBooleanField.Create(Self);
  Grade_ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  Grade_ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Grade_ProdutosDataset.BeforeLoadDFMValues;
  Grade_ProdutosDatasetid.BeforeLoadDFMValues;
  Grade_ProdutosDatasetaliado_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetgrade_linha_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetgrade_coluna_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetprodutos_id.BeforeLoadDFMValues;
  Grade_ProdutosDatasetnome.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_fabrica.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_retido.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_maximo.BeforeLoadDFMValues;
  Grade_ProdutosDatasetestoque_minimo.BeforeLoadDFMValues;
  Grade_ProdutosDatasetstatus.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcadastro.BeforeLoadDFMValues;
  Grade_ProdutosDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_ProdutosDatasetexcluido.BeforeLoadDFMValues;
  Grade_ProdutosDatasetinclusao.BeforeLoadDFMValues;
  Grade_ProdutosDatasetalteracao.BeforeLoadDFMValues;
  Grade_ProdutosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_ProdutosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_linha_id';
      Title := 'grade_linha_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_coluna_id';
      Title := 'grade_coluna_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produtos_id';
      Title := 'produtos_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'codigo_barras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_fabrica';
      Title := 'codigo_fabrica';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque';
      Title := 'estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque_retido';
      Title := 'estoque_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque_maximo';
      Title := 'estoque_maximo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque_minimo';
      Title := 'estoque_minimo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Grade_ProdutosDataset.SetParentComponent(Self);
    Grade_ProdutosDataset.Name := 'Grade_ProdutosDataset';
    Grade_ProdutosDataset.EntitySetName := 'Grade_Produtos';
    Grade_ProdutosDataset.Connection := DMConnection.ApiConnection;
    Grade_ProdutosDataset.Left := 72;
    Grade_ProdutosDataset.Top := 144;
    Grade_ProdutosDatasetid.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetid.Name := 'Grade_ProdutosDatasetid';
    Grade_ProdutosDatasetid.FieldName := 'id';
    Grade_ProdutosDatasetid.Required := True;
    Grade_ProdutosDatasetaliado_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetaliado_id.Name := 'Grade_ProdutosDatasetaliado_id';
    Grade_ProdutosDatasetaliado_id.FieldName := 'aliado_id';
    Grade_ProdutosDatasetaliado_id.Required := True;
    Grade_ProdutosDatasetdata_base_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetdata_base_id.Name := 'Grade_ProdutosDatasetdata_base_id';
    Grade_ProdutosDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_ProdutosDatasetdata_base_id.Required := True;
    Grade_ProdutosDatasetgrade_linha_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetgrade_linha_id.Name := 'Grade_ProdutosDatasetgrade_linha_id';
    Grade_ProdutosDatasetgrade_linha_id.FieldName := 'grade_linha_id';
    Grade_ProdutosDatasetgrade_linha_id.Required := True;
    Grade_ProdutosDatasetgrade_coluna_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetgrade_coluna_id.Name := 'Grade_ProdutosDatasetgrade_coluna_id';
    Grade_ProdutosDatasetgrade_coluna_id.FieldName := 'grade_coluna_id';
    Grade_ProdutosDatasetgrade_coluna_id.Required := True;
    Grade_ProdutosDatasetprodutos_id.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetprodutos_id.Name := 'Grade_ProdutosDatasetprodutos_id';
    Grade_ProdutosDatasetprodutos_id.FieldName := 'produtos_id';
    Grade_ProdutosDatasetprodutos_id.Required := True;
    Grade_ProdutosDatasetnome.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetnome.Name := 'Grade_ProdutosDatasetnome';
    Grade_ProdutosDatasetnome.FieldName := 'nome';
    Grade_ProdutosDatasetnome.Required := True;
    Grade_ProdutosDatasetnome.Size := 255;
    Grade_ProdutosDatasetcodigo_barras.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_barras.Name := 'Grade_ProdutosDatasetcodigo_barras';
    Grade_ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    Grade_ProdutosDatasetcodigo_barras.Size := 255;
    Grade_ProdutosDatasetcodigo_fabrica.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_fabrica.Name := 'Grade_ProdutosDatasetcodigo_fabrica';
    Grade_ProdutosDatasetcodigo_fabrica.FieldName := 'codigo_fabrica';
    Grade_ProdutosDatasetcodigo_fabrica.Size := 255;
    Grade_ProdutosDatasetestoque.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque.Name := 'Grade_ProdutosDatasetestoque';
    Grade_ProdutosDatasetestoque.FieldName := 'estoque';
    Grade_ProdutosDatasetestoque_retido.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_retido.Name := 'Grade_ProdutosDatasetestoque_retido';
    Grade_ProdutosDatasetestoque_retido.FieldName := 'estoque_retido';
    Grade_ProdutosDatasetestoque_retido.Required := True;
    Grade_ProdutosDatasetestoque_maximo.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_maximo.Name := 'Grade_ProdutosDatasetestoque_maximo';
    Grade_ProdutosDatasetestoque_maximo.FieldName := 'estoque_maximo';
    Grade_ProdutosDatasetestoque_minimo.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetestoque_minimo.Name := 'Grade_ProdutosDatasetestoque_minimo';
    Grade_ProdutosDatasetestoque_minimo.FieldName := 'estoque_minimo';
    Grade_ProdutosDatasetstatus.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetstatus.Name := 'Grade_ProdutosDatasetstatus';
    Grade_ProdutosDatasetstatus.FieldName := 'status';
    Grade_ProdutosDatasetstatus.Required := True;
    Grade_ProdutosDatasetcadastro.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcadastro.Name := 'Grade_ProdutosDatasetcadastro';
    Grade_ProdutosDatasetcadastro.FieldName := 'cadastro';
    Grade_ProdutosDatasetcodigo_interno.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetcodigo_interno.Name := 'Grade_ProdutosDatasetcodigo_interno';
    Grade_ProdutosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_ProdutosDatasetcodigo_interno.Required := True;
    Grade_ProdutosDatasetexcluido.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetexcluido.Name := 'Grade_ProdutosDatasetexcluido';
    Grade_ProdutosDatasetexcluido.FieldName := 'excluido';
    Grade_ProdutosDatasetinclusao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetinclusao.Name := 'Grade_ProdutosDatasetinclusao';
    Grade_ProdutosDatasetinclusao.FieldName := 'inclusao';
    Grade_ProdutosDatasetalteracao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetalteracao.Name := 'Grade_ProdutosDatasetalteracao';
    Grade_ProdutosDatasetalteracao.FieldName := 'alteracao';
    Grade_ProdutosDatasetexclusao.SetParentComponent(Grade_ProdutosDataset);
    Grade_ProdutosDatasetexclusao.Name := 'Grade_ProdutosDatasetexclusao';
    Grade_ProdutosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Grade_ProdutosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Grade_ProdutosDataset.AfterLoadDFMValues;
    Grade_ProdutosDatasetid.AfterLoadDFMValues;
    Grade_ProdutosDatasetaliado_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetdata_base_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetgrade_linha_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetgrade_coluna_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetprodutos_id.AfterLoadDFMValues;
    Grade_ProdutosDatasetnome.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_fabrica.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_retido.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_maximo.AfterLoadDFMValues;
    Grade_ProdutosDatasetestoque_minimo.AfterLoadDFMValues;
    Grade_ProdutosDatasetstatus.AfterLoadDFMValues;
    Grade_ProdutosDatasetcadastro.AfterLoadDFMValues;
    Grade_ProdutosDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_ProdutosDatasetexcluido.AfterLoadDFMValues;
    Grade_ProdutosDatasetinclusao.AfterLoadDFMValues;
    Grade_ProdutosDatasetalteracao.AfterLoadDFMValues;
    Grade_ProdutosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
